import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type {
  ManualStandardRequirementItem,
  ManualStandardRequirementItemWithValidation,
} from '@/shared/hooks/api/machineryDirectiveCompliance'
import { cn } from '@/shared/lib/utils'

export function CraRequirementItem({
  item,
  validationItem,
  isProcessing,
}: {
  item: ManualStandardRequirementItem
  validationItem?: ManualStandardRequirementItemWithValidation
  isProcessing?: boolean
}) {
  const { t } = useTranslation('craCompliance')
  const hasValidation = validationItem !== undefined
  const isVerified = validationItem?.verified === true
  let explanation = ''
  if (validationItem != null && !isProcessing) {
    explanation = validationItem.explanation
  }
  const showExplanation = explanation.length > 0
  let explanationClassName =
    'mt-2 overflow-hidden rounded-md border p-2 text-xs italic border-destructive/30 bg-destructive/10 text-destructive dark:border-destructive/50 dark:bg-destructive/20 dark:text-destructive'
  if (isVerified) {
    explanationClassName =
      'mt-2 overflow-hidden rounded-md border p-2 text-xs italic border-green-200 bg-green-50 text-green-700 dark:border-green-600 dark:bg-green-950/50 dark:text-green-500'
  }
  let markClassName = 'text-lg font-bold text-destructive'
  if (isVerified) {
    markClassName = 'text-lg font-bold text-green-600 dark:text-green-500'
  }
  let mark = '✗'
  if (isVerified) {
    mark = '✓'
  }

  return (
    <>
      <div className='min-w-0 flex-1 wrap-break-word'>
        <span
          className={cn(
            'flex gap-2 text-muted-foreground',
            isProcessing && 'text-primary italic'
          )}
        >
          <span className='shrink-0 font-medium text-muted-foreground'>
            {item.number}
          </span>
          <span>{item.text}</span>
        </span>
        {isProcessing && (
          <p className='mt-1 text-xs text-primary italic'>
            {t('userInformation.processing')}
          </p>
        )}
        {showExplanation && (
          <div className={explanationClassName}>{explanation}</div>
        )}
      </div>

      <span className='flex w-10 shrink-0 items-center justify-center gap-2 font-medium'>
        {isProcessing && (
          <Loader2 className='size-4 animate-spin text-primary' />
        )}
        {hasValidation && !isProcessing && (
          <span className={markClassName}>{mark}</span>
        )}
      </span>
    </>
  )
}
